<div class="sercon-hero mobi-ui-margin-b-xxl smMax:full-bleed">
  <div class="smMax:!container-padding">
    <mobi-breadcrumb />
  </div>
  <div
    class="mobi-ui-card-silent mobi-ui-relative mobi-ui-padding-t-sm mobi-ui-padding-b-xl mobi-ui-margin-t-sm mobi-ui-padding-x-none view-enter-animation smMax:!container-padding"
  >
    <div class="mobi-ui-grid smMax:!flex-col-reverse">
      <div class="mobi-ui-col-1/1 md:mobi-ui-col-7/16 md:mobi-ui-offset-1/16">
        <mobi-hero-text
          [superTitle]="entity().superTitle"
          [subtitle]="entity().subtitle"
          [lead]="entity().lead"
          [title]="entity().title"
          [fullWidth]="true"
          [secondaryCta]="entity().emergencyCta | extractUrl"
          [secondaryCtaTitle]="entity().emergencyCtaLabel"
          [secondaryCtaLabel]="entity().emergencyCta?.title"
          [secondaryCtaTarget]="entity().emergencyCta?.options?.attributes?.target"
          [secondaryCtaIcon]="emergencyCtaIcon"
        />
      </div>
      @if (entity().heroIllustration) {
        <div
          class="smMax:w-full mobi-ui-col-1/1 md:mobi-ui-col-7/16 lg:mobi-ui-col-6/16 md:mobi-ui-offset-1/16"
        >
          @defer (hydrate never) {
            <mobi-ui-illustration-major
              class="block"
              [illustration]="entity().heroIllustration"
              [lazy]="false"
            />
          }
        </div>
      }
    </div>
  </div>
</div>
<div class="split-button-wrapper w-full mx-auto is-bottom-center hide-scrollbars">
  <div class="w-full md:w-fit md:min-w-[400px] mx-auto">
    @if (visiblePage().length > 0) {
      <mobi-ui-split-button-group-supreme
        [value]="visiblePage()"
        [class.initial-contact]="visiblePage() === 'contact' && !hasSwitchedPage()"
        (valueChange)="changePage('' + $event)"
        #splitButton
      >
        <mobi-ui-split-button-supreme
          value="services"
          [active]="visiblePage() === 'services'"
        >
          <span class="whitespace-nowrap">
            {{
              'online_services_label'
                | texts: { context: 'frontend', default: 'Online Services' }
            }}
          </span>
        </mobi-ui-split-button-supreme>
        <mobi-ui-split-button-supreme
          value="contact"
          [active]="visiblePage() === 'contact'"
        >
          <span class="whitespace-nowrap">
            {{ 'contact_label' | texts: { context: 'frontend', default: 'Kontakt' } }}
          </span>
        </mobi-ui-split-button-supreme>
      </mobi-ui-split-button-group-supreme>
    }
  </div>
</div>
<div id="scroll-to-view"></div>
@if (visiblePage() === 'services') {
  <div id="services-page" class="main-services">
    <div class="page-content !mt-0">
      <mobi-content-section width="full" [content]="mainServices" [background]="true">
        <ng-template #mainServices>
          <mobi-section-title
            class="block mobi-ui-padding-y-xl"
            [title]="entity().mainServicesTitle"
          />
          <div class="mobi-ui-grid is-centered">
            <div
              class="mobi-ui-col-1/1 md:mobi-ui-col-7/8 lg:mobi-ui-col-1/1 xl:mobi-ui-col-7/8"
            >
              @defer (hydrate on viewport) {
                @if (mainTeasers().length > 0) {
                  <mobi-teaser-list
                    class="mobi-sercon-main-teasers"
                    [teasers]="mainTeasers()"
                    teaserStyle="icon-stacked-bottom"
                    [inked]="true"
                  ></mobi-teaser-list>
                }
              }
            </div>
            <div class="mobi-ui-col-1/1 lg:mobi-ui-col-5/8">
              <h5 class="mobi-ui-text-inked mobi-ui-text-center mobi-ui-padding-b-md">
                {{
                  'further_topics_on_this_page_label'
                    | texts
                      : {
                          context: 'frontend',
                          default: 'Weitere Themen auf dieser Seite',
                        }
                }}
              </h5>
              @if (contentLinks()) {
                <mobi-content-links [contentLinks]="contentLinks()" [isCentered]="true" />
              }
            </div>
          </div>
        </ng-template>
      </mobi-content-section>
      @if (entity().damageReportServices && entity().damageReportServices.length > 0) {
        <div class="content-section damage-reports-services">
          <div>
            <mobi-service-infobox
              [superTitle]="entity().damageReportServicesSuperTitle"
              [title]="entity().damageReportServicesTitle"
              [services]="entity().damageReportServices"
              [sectionId]="
                'damage_report_services_paramenter_name'
                  | texts: { context: 'frontend', default: 'schaden' }
              "
              [illustration]="{
                name: 'basic_people_research_tablet',
                file: { entity: { filename: 'basic_people_research_tablet.svg' } },
              }"
            ></mobi-service-infobox>
          </div>
        </div>
      }

      @if (
        entity().administrativeServices && entity().administrativeServices.length > 0
      ) {
        <div class="content-section administrative-services">
          <div>
            <mobi-service-infobox
              [superTitle]="entity().administrativeServicesSuperTitle"
              [title]="entity().administrativeServicesTitle"
              [services]="entity().administrativeServices"
              [sectionId]="
                'administrative_services_parameter_name'
                  | texts: { context: 'frontend', default: 'administratives' }
              "
              [illustration]="{
                name: 'basic_family_house_outside',
                file: { entity: { filename: 'basic_family_house_outside.svg' } },
              }"
            ></mobi-service-infobox>
          </div>
        </div>
      }
      @if (entity().mobilityServices && entity().mobilityServices.length > 0) {
        <div class="content-section mobility-services">
          <div>
            <mobi-service-infobox
              [superTitle]="entity().mobilityServicesSuperTitle"
              [title]="entity().mobilityServicesTitle"
              [services]="entity().mobilityServices"
              [sectionId]="
                'mobility_services_paramenter_name'
                  | texts: { context: 'frontend', default: 'mobilitaet' }
              "
              [illustration]="{
                name: 'other_car_check',
                file: { entity: { filename: 'other_car_check.svg' } },
              }"
            ></mobi-service-infobox>
          </div>
        </div>
      }

      @if (entity().invoiceServices && entity().invoiceServices.length > 0) {
        <div class="content-section invoice-services">
          <div>
            <mobi-service-infobox
              [superTitle]="entity().invoiceServicesSuperTitle"
              [title]="entity().invoiceServicesTitle"
              [services]="entity().invoiceServices"
              [sectionId]="
                'invoice_services_paramenter_name'
                  | texts: { context: 'frontend', default: 'rechnungen' }
              "
            ></mobi-service-infobox>
          </div>
        </div>
      }

      @if (
        entity().customerBenefitsServices && entity().customerBenefitsServices.length > 0
      ) {
        <div class="content-section customer-benefits-services">
          <div>
            <mobi-service-infobox
              [superTitle]="entity().customerBenefitsServicesSuperTitle"
              [title]="entity().customerBenefitsServicesTitle"
              [services]="entity().customerBenefitsServices"
              [sectionId]="
                'customer_benefits_services_paramenter_name'
                  | texts: { context: 'frontend', default: 'kundenvorteile' }
              "
              [illustration]="{
                name: 'other_gondola_mountain',
                file: { entity: { filename: 'other_gondola_mountain.svg' } },
              }"
            ></mobi-service-infobox>
          </div>
        </div>
      }

      <div class="content-section is-background">
        <div><mobi-concierge /></div>
      </div>
    </div>
  </div>
}
@if (visiblePage() === 'contact') {
  <div
    id="contact-page"
    class="view-enter-animation"
    [class.hidden]="visiblePage() !== 'contact'"
  >
    <div class="page-content !mt-0">
      <h2 class="text-center mobi-ui-padding-y-xl">
        {{
          'ga_search_map_title'
            | texts
              : {
                  context: 'frontend',
                  default: 'Finden Sie die Filiale in Ihrer Nähe.',
                }
        }}
      </h2>

      <div class="content-section">
        <div>
          <div id="map" class="mobi-ui-grid is-centered">
            <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4">
              <mobi-ga-search />
            </div>
          </div>
        </div>
      </div>
      @if (entity().contactParagraphs) {
        @for (paragraph of entity().contactParagraphs; track paragraph?.uuid ?? $index) {
          @if (paragraph) {
            <mobi-paragraph-loader
              [bundle]="paragraph.type"
              [data]="{ paragraph: paragraph }"
            />
          }
        }
      }
    </div>
  </div>
}

<ng-template #pgs let-paragraph="paragraph">
  @if (paragraph.type === 'ParagraphPgTl') {
    <mobi-paragraph-loader
      [bundle]="paragraph.type"
      [data]="{
        paragraph: paragraph,
        teaserStyle: 'stacked',
      }"
    />
  } @else if (paragraph.type === 'ParagraphPgForm') {
    <div class="is-background">
      <ng-content /><mobi-paragraph-loader
        [bundle]="paragraph.type"
        [data]="{ paragraph: paragraph }"
      />
    </div>
  } @else {
    <mobi-paragraph-loader [bundle]="paragraph.type" [data]="{ paragraph: paragraph }" />
  }
</ng-template>
